(function () {
    var modal = document.querySelector('[data-gallery-modal]');
    if (!modal) return;

    var triggers = Array.prototype.slice.call(document.querySelectorAll('.archive-gallery-trigger'));
    var modalImage = modal.querySelector('[data-gallery-modal-image]');
    var closeButtons = modal.querySelectorAll('[data-gallery-close]');
    var prevButton = modal.querySelector('[data-gallery-prev]');
    var nextButton = modal.querySelector('[data-gallery-next]');
    var currentIndex = 0;

    var images = triggers.map(function (trigger) {
        return {
            src: trigger.getAttribute('data-gallery-full'),
            alt: trigger.getAttribute('data-gallery-alt') || ''
        };
    });

    function renderImage() {
        if (!images.length) return;
        if (currentIndex < 0) currentIndex = images.length - 1;
        if (currentIndex >= images.length) currentIndex = 0;
        modalImage.src = images[currentIndex].src;
        modalImage.alt = images[currentIndex].alt;
    }

    function openModal(index) {
        currentIndex = index;
        renderImage();
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
    }

    function closeModal() {
        modal.hidden = true;
        document.body.style.overflow = '';
    }

    triggers.forEach(function (trigger, index) {
        trigger.addEventListener('click', function () {
            openModal(index);
        });
    });

    closeButtons.forEach(function (button) {
        button.addEventListener('click', closeModal);
    });

    prevButton.addEventListener('click', function () {
        currentIndex -= 1;
        renderImage();
    });

    modalImage.addEventListener('click', function () {
        currentIndex += 1;
        renderImage();
    });

    nextButton.addEventListener('click', function () {
        currentIndex += 1;
        renderImage();
    });

    document.addEventListener('keydown', function (event) {
        if (modal.hidden) return;
        if (event.key === 'Escape') closeModal();
        if (event.key === 'ArrowLeft') {
            currentIndex -= 1;
            renderImage();
        }
        if (event.key === 'ArrowRight') {
            currentIndex += 1;
            renderImage();
        }
    });
})();